// extracted by mini-css-extract-plugin
module.exports = {"pointer":"styles-module--pointer--34feS","pointerflipped":"styles-module--pointerflipped--2LrbD"};